import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const ExitBriefPrompt = () => {
  const { user } = useAuth();
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user?.role !== "advocate") return;
    api.get("/advocate-changes/pending-exit").then(({ data }) => setRows(data)).catch(() => {});
  }, [user]);

  const row = rows[0];
  if (!row) return null;

  const exit = async () => {
    setBusy(true);
    try {
      await api.post(`/advocate-changes/${row.id}/exit`);
      toast.success("Exit from brief acknowledged");
      setRows((r) => r.slice(1));
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open onOpenChange={(o) => { if (!o) setRows((r) => r.slice(1)); }}>
      <DialogContent className="rounded-none" data-testid="exit-brief-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">Exit from brief · {row.case_ref}</DialogTitle>
          <DialogDescription>
            {row.requested_by_name} has asked {row.new_name} ({row.new_email}) to take over as {row.side}'s counsel in
            {" "}{row.case_title}. Your access to this reference will end once the new counsel accepts; your past
            filings remain on record. Please acknowledge your exit from the brief.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" className="rounded-none uppercase tracking-widest text-xs" data-testid="exit-brief-later"
            onClick={() => setRows((r) => r.slice(1))}>Later</Button>
          <Button disabled={busy} className="rounded-none bg-red-800 hover:bg-red-700 text-white uppercase tracking-widest text-xs"
            data-testid="exit-brief-confirm" onClick={exit}>{busy ? "Recording…" : "Exit brief"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
